import { DateTime } from 'luxon';
export var getDaysWithShifts = function (scheduleShifts) {
    if (!scheduleShifts) {
        return [];
    }
    var result = new Set();
    for (var _i = 0, scheduleShifts_1 = scheduleShifts; _i < scheduleShifts_1.length; _i++) {
        var scheduleShift = scheduleShifts_1[_i];
        var shiftStart = scheduleShift.shift.timeRange.start;
        result.add(DateTime.fromISO(shiftStart));
    }
    return Array.from(result);
};
